module.exports = __webpack_public_path__ + "media/img/event/Scholarships2u-Citibank-Scholarships_Banner2-69bf4b65bed1bb8c0d30e88775dece02.jpg";